import React from 'react';
import Icon from '../../../components/AppIcon';

const StatisticsCard = ({ icon, label, value, trend, trendValue, color = 'primary' }) => {
  const colorClasses = {
    primary: 'bg-primary/20 text-primary',
    success: 'bg-success/20 text-success',
    accent: 'bg-accent/20 text-accent',
    warning: 'bg-warning/20 text-warning',
  };

  const trendColors = {
    up: 'text-success',
    down: 'text-error',
    neutral: 'text-muted-foreground',
  };

  return (
    <div className="bg-card rounded-md md:rounded-lg shadow-gaming-md p-3 sm:p-4 md:p-6 transition-gaming hover:shadow-gaming-lg">
      <div className="flex items-start justify-between mb-2 sm:mb-3 md:mb-4">
        <div className={`w-9 h-9 sm:w-10 sm:h-10 md:w-14 md:h-14 rounded-md flex items-center justify-center ${colorClasses?.[color]}`}>
          <Icon name={icon} size={20} className="md:w-7 md:h-7" />
        </div>
        {trend && (
          <div className={`hidden sm:flex items-center space-x-1 ${trendColors?.[trend]}`}>
            <Icon name={trend === 'up' ? 'TrendingUp' : trend === 'down' ? 'TrendingDown' : 'Minus'} size={16} />
            <span className="text-xs md:text-sm font-medium caption">{trendValue}</span>
          </div>
        )}
      </div>
      <div className="space-y-1">
        <h3 className="text-lg sm:text-xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground data-text">
          {value?.toLocaleString('ko-KR')}
        </h3>
        <p className="text-xs sm:text-sm md:text-base text-muted-foreground">{label}</p>
      </div>
    </div>
  );
};

export default StatisticsCard;